// extracted by mini-css-extract-plugin
export default {"wrapper":"time-picker_wrapper__sUgfz","input":"time-picker_input__+3P1z"};